import { constants } from "@newsela/angelou";
import { CSSObject } from "@emotion/react";
import { typographyStyles } from "@newsela/angelou";
import {
  gradientBackgrounds,
  gradientColors,
} from "@/components/AIComponents/AiComponents.style";

const { heading4 } = typographyStyles;
const { ui } = constants.colors;

export const listCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "100%",
  width: "225px",
  minWidth: "225px",
  overflowY: "auto",
  gap: ".5em",
  padding: 0,
  margin: 0,
  listStyle: "none",
};

export const defaultButtonCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  border: `2px solid ${ui.core[100]}`,
  padding: "10px",
  borderRadius: "4px",
  color: ui.black[100],
  background: gradientBackgrounds[100],
  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
  height: "158px",
  width: "100%",
  "&:hover, &:focus, &:focus-visible": {
    background: gradientBackgrounds[200],
  },
  "& h3": {
    margin: "0 0 5px 0",
    heading4,
  },
  "& img": {
    maxWidth: "124px",
    maxHeight: "100%",
    borderRadius: "4px",
    alignSelf: "center",
  },
};

export const selectedButtonCss: CSSObject = {
  ...defaultButtonCss,
  position: "relative",
  border: "2px solid transparent",
  borderRadius: "4px",
  padding: "14px",
  background: gradientBackgrounds[200],
  borderImage: `linear-gradient(
    to bottom right,
    ${gradientColors.position0},
    ${gradientColors.position25},
    ${gradientColors.position50},
    ${gradientColors.position100}
  ) 1`,
};
